import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b41ddce8")

_pushScopeId("data-v-b41ddce8")
const _hoisted_1 = { class: "salary-calculator" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "col-6" }, " Uw bruto maandloon ", -1)
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = {
  key: 0,
  class: "row"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "col-6" }, " U wordt uitbetaald per ", -1)
const _hoisted_7 = { class: "col-6" }
const _hoisted_8 = {
  key: 1,
  class: "row"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "col-6" }, " Ontvangt u vakantiegeld? ", -1)
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = {
  key: 2,
  class: "row"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "col-6" }, " Ontvangt u een 13e maand? ", -1)
const _hoisted_13 = { class: "col-6" }
const _hoisted_14 = {
  key: 3,
  class: "row result"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "col-6" }, " Uw bruto jaarloon ", -1)
const _hoisted_16 = { class: "col-6 total" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CurrencyInput = _resolveComponent("CurrencyInput")
  const _component_Radio = _resolveComponent("Radio")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_CurrencyInput, {
          modelValue: _ctx.grossMonthlySalary,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.grossMonthlySalary = $event))
        }, null, 8, ["modelValue"])
      ])
    ]),
    (_ctx.grossMonthlySalary !== null)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _hoisted_6,
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_Radio, {
              modelValue: _ctx.payPeriod,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.payPeriod = $event)),
              value: _ctx.PayPeriod.Month,
              inline: "",
              label: "Maand",
              name: "payment_period"
            }, null, 8, ["modelValue", "value"]),
            _createVNode(_component_Radio, {
              modelValue: _ctx.payPeriod,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.payPeriod = $event)),
              value: _ctx.PayPeriod.FourWeeks,
              inline: "",
              label: "4 weken",
              name: "payment_period"
            }, null, 8, ["modelValue", "value"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.payPeriod !== null)
      ? (_openBlock(), _createBlock("div", _hoisted_8, [
          _hoisted_9,
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_Radio, {
              modelValue: _ctx.holidayPay,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (_ctx.holidayPay = $event)),
              value: true,
              inline: "",
              label: "Ja",
              name: "holiday_pay"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Radio, {
              modelValue: _ctx.holidayPay,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (_ctx.holidayPay = $event)),
              value: false,
              inline: "",
              label: "Nee",
              name: "holiday_pay"
            }, null, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.holidayPay !== null && _ctx.payPeriod === _ctx.PayPeriod.Month)
      ? (_openBlock(), _createBlock("div", _hoisted_11, [
          _hoisted_12,
          _createVNode("div", _hoisted_13, [
            _createVNode(_component_Radio, {
              modelValue: _ctx.extraMonth,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (_ctx.extraMonth = $event)),
              value: true,
              inline: "",
              label: "Ja",
              name: "extra_month"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Radio, {
              modelValue: _ctx.extraMonth,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (_ctx.extraMonth = $event)),
              value: false,
              inline: "",
              label: "Nee",
              name: "extra_month"
            }, null, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isComplete)
      ? (_openBlock(), _createBlock("div", _hoisted_14, [
          _hoisted_15,
          _createVNode("div", _hoisted_16, _toDisplayString(_ctx.formattedSalary), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
})